// ------------------------------------
// Constants
// ------------------------------------
// prettier-ignore
export const NOTIFICATION_TOUCH_PUT_REQUEST = 'NOTIFICATION_TOUCH_PUT_REQUEST';
// prettier-ignore
export const NOTIFICATION_TOUCH_PUT_REQUEST_SUCCESS = 'NOTIFICATION_TOUCH_PUT_REQUEST_SUCCESS';
// prettier-ignore
export const NOTIFICATION_TOUCH_PUT_REQUEST_FAILURE = 'NOTIFICATION_TOUCH_PUT_REQUEST_FAILURE';

// ------------------------------------
// Actions
// ------------------------------------
export function request(id, userId) {
  return {
    type: NOTIFICATION_TOUCH_PUT_REQUEST,
    id,
    userId,
  };
}

export function requestSuccess(res, id, unreadCount, userId) {
  return {
    type: NOTIFICATION_TOUCH_PUT_REQUEST_SUCCESS,
    data: res,
    id,
    unreadCount,
    userId,
  };
}

export function requestFailure(error, id) {
  return {
    type: NOTIFICATION_TOUCH_PUT_REQUEST_FAILURE,
    error,
    id,
  };
}
